
  import {Component, Vue} from 'vue-property-decorator';
  import AppDialog from '@/modules/Popup/components/AppDialog.vue';
  import {httpResource} from "@/resources/http.resource";
  import {IUploadFiles} from "@/interfaces/upload-files.interface";
  import {ICarList} from "@/modules/CarList/interfaces/car-list.interface";
  import AppCorpsFilter from "@/components/FormControls/AppCorpsFilter.vue";

  @Component({
    components: {
      AppCorpsFilter,
      AppDialog,
    },
  })
  export default class UploadCarsExcelPopup extends Vue {
    $refs: any;
    currentPopup = { blockName: 'carList', dialogName: 'uploadCrsExcel' };
    uploadedFile = '';
    corpId = null;
    corpName = '';

    get corps() { return this.$store.state.book.books.corps; }

    async mounted() {
      let storageCorp: any = window.localStorage.getItem(ICarList.LocalStorageKeys.CorpIdForUploadCars);
      if (storageCorp) {
        storageCorp = JSON.parse(storageCorp);
        this.corpId = storageCorp.id;
        this.corpName = storageCorp.name;
      }
      else if (this.corps.length === 1) this.corpId = this.corps[0].id;
    }

    async upload(file) {
      if (this.$refs.uploadDoc.uploadFiles.length > 1) {
        this.$refs.uploadDoc.handleRemove(this.$refs.uploadDoc.uploadFiles[0]);
      }
      this.uploadedFile = file.name;

      let asyncAction = async () => {
        const url = `${process.env.VUE_APP_HOST}upload-test?type=1&filename=${this.uploadedFile}`;
        const data = {
          'Content-Type': 'multipart/form-data',
          name: file.name,
          filename: file.raw,
        };
        const response: any = await httpResource.customHttpAction({ url, data, withFormData: true });
        if (response.status === 200) {
          await this.sendFileData(response.data);
        }
        else {
          const params = {
            textId: 'error.customText',
            payload: response.data.extra
          };
          await this.$store.dispatch('error/open', params);
        }

        await this.onClose();
      };
      await this.$store.dispatch('defaultResourceAction', { asyncAction });
    }

    async sendFileData(fileData: any) {
      let asyncAction = async () => {
        const action = IUploadFiles.Action.UploadFile;
        const params = {
          filename: fileData.filename,
          originalName: fileData.originalname,
          loadType: 'CarImport',
          loadId: this.corpId,
        };
        await httpResource.httpAction({ action, params });
        this.$notify({
          title: 'Успешно',
          message: `Файл успешно загружен. Смотрите историю обработки в журнале.`,
          type: 'success'
        });
      };
      await this.$store.dispatch('defaultResourceAction', { asyncAction });
    }

    async onClose() {
      this.$refs.appDialog.onClose();
    }

    saveCorpId(bookValue) {
      if (!Boolean(bookValue)) return;
      window.localStorage.setItem(ICarList.LocalStorageKeys.CorpIdForUploadCars, JSON.stringify(bookValue));
    }

  }
